import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

const APP_NAME = 'Nfarm';

/**
 * Titolo del documento aggiornato a ogni navigazione (WCAG 2.4.2). Un titolo
 * unico per tutta l'applicazione non dice dove si è: chi naviga fra schede,
 * usa la cronologia o ascolta un lettore di schermo si orienta con questo.
 *
 * Il testo viene dai `breadcrumb` già dichiarati nelle rotte, quindi non c'è
 * un secondo elenco da tenere allineato.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
  constructor(private readonly title: Title) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const explicit = this.buildTitle(snapshot);
    const fromBreadcrumb = this.lastBreadcrumbLabel(snapshot);
    const page = explicit ?? fromBreadcrumb;

    this.title.setTitle(page ? `${page} · ${APP_NAME}` : APP_NAME);
  }

  /** Ultima voce del percorso: è la pagina in cui ci si trova. */
  private lastBreadcrumbLabel(snapshot: RouterStateSnapshot): string | null {
    let route = snapshot.root;
    let label: string | null = null;

    while (route) {
      const crumbs = route.data?.['breadcrumb'];
      if (Array.isArray(crumbs) && crumbs.length) {
        const last = crumbs[crumbs.length - 1] as { label?: unknown };
        if (typeof last?.label === 'string' && last.label.trim()) {
          label = last.label;
        }
      }
      route = route.firstChild as typeof route;
    }

    return label;
  }
}
